import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Typography, Grid, Divider, useMediaQuery } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IntlMessages from 'lngProvider/IntlMessages';
import { styled } from '@mui/material/styles';
import { spacing } from 'styles/Common';

const StyledDialog = styled(Dialog)((
    {
        theme
    }
) => {
    return {
        '& .dialog-close-button': {
            position: 'absolute',
            top: 0,
            right: 0,
            padding: 5,
            lineHeight: '14px',
            minWidth: 'auto',
            textAlign: 'right'
        },
        '& .account-subtitle': {
            fontWeight: 'bold',
            marginBottom: spacing[2]
        },
        '& .description-text': {
            marginBottom: spacing[2],
            [theme.breakpoints.up('lg')]: {
                width: 480
            }
        },
        '& .close-button': {
            [theme.breakpoints.up('md')]: {
                width: 90
            }

        }
    };
});

const AccountAlreadyExistsModal = ({ open, applications, values, setValues, onClose }) => {
    const theme = useTheme();
    const isSmOrDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <StyledDialog
            open={open}
            keepMounted
            fullScreen={isSmOrDown}
            style={{ zIndex: theme.zIndex.modal + 2 }}>

            <DialogTitle>
                <Grid container alignItems="center" justifyContent="center">
                    <Typography variant="h6"><IntlMessages id="accountExists.title" /></Typography>
                </Grid>
                <div className="dialog-close-button">
                    <IconButton onClick={() => onClose(values, setValues)}><CloseIcon /></IconButton>
                </div>
                <Divider />
            </DialogTitle>

            <DialogContent>
                <Typography className="account-subtitle"><IntlMessages id="accountExists.subTitle" /></Typography>
                <Typography variant="body2" className="description-text"><IntlMessages id="accountExists.description" /></Typography>
                <Typography variant="body2"><IntlMessages id="accountExists.accessTo" /></Typography>
                {applications.map((a, idx) => <Typography variant="body2" key={idx}>{a}</Typography>)}
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" color="inherit" className="close-button" onClick={() => onClose(values, setValues)}>
                    <IntlMessages id="accountExists.close" />
                </Button>
            </DialogActions>
        </StyledDialog>
    );
}

export default AccountAlreadyExistsModal;